/**
 * Filtrar una lista por lo que se escribe en su buscador, sin tildes ni
 * mayúsculas y por PALABRAS: «reforma bano» encuentra «Reforma de baño».
 *
 * Lo pidió el propietario tras probar Productos en staging (2026-10-25): el
 * buscador comparaba el texto entero tal cual, y «reforma bano» no encontraba
 * nada. Es la misma regla que `clientes-parecidos.ts`, para que todos los
 * buscadores de la aplicación respondan igual.
 *
 * Solo filtra lo que la pantalla ya tiene: no pide nada a la API.
 */
import { normalizarNombre } from "./clientes-parecidos";

/** Cada palabra de `consulta` está en alguno de los `textos`. Sin consulta, todo coincide. */
export function coincide(consulta: string, ...textos: ReadonlyArray<string | null | undefined>): boolean {
  const palabras = normalizarNombre(consulta).split(" ").filter((p) => p !== "");
  if (palabras.length === 0) return true;
  const juntos = textos
    .filter((x): x is string => typeof x === "string")
    .map(normalizarNombre)
    .join(" ");
  return palabras.every((p) => juntos.includes(p));
}

/**
 * El id de la opción de un buscador (`Buscador` de `primitivas.tsx`) que
 * señala `escrito`, o `null` si no hay UNA sola: primero el texto exacto de la
 * opción, después sus `claves` (el nombre solo, el NIF) sin tildes ni
 * mayúsculas. Dos clientes con el mismo nombre siguen obligando a elegir.
 */
export function opcionQueCoincide(
  opciones: ReadonlyArray<{ readonly id: string; readonly texto: string; readonly claves?: ReadonlyArray<string | null> }>,
  escrito: string,
): string | null {
  const exacta = opciones.find((o) => o.texto === escrito);
  if (exacta !== undefined) return exacta.id;
  const n = normalizarNombre(escrito);
  if (n === "") return null;
  const porClave = opciones.filter((o) => (o.claves ?? []).some((c) => c !== null && normalizarNombre(c) === n));
  return porClave.length === 1 ? (porClave[0]?.id ?? null) : null;
}
